/**
 * IntersectionObserverAPIでclassやdata属性を変えるクラス
 */

export default class IntersectionObserverHeaderAnima {
  constructor(_parm) {
  }

  init() {
    // 監視対象の要素
    this.elmTargetObserve = document.querySelector('#js-header-observer-trigger');
    if (!this.elmTargetObserve) return;
    // ヘッダー
    this.elmHeader = document.querySelector('#js-header');
    // 固定ボタン（TOPに戻る）
    this.elmFixedBtn = document.querySelector('#js-return-top-btn');
    // オプション
    const options = {
      root: null, // 今回はビューポートをルート要素とする
      rootMargin: '-50% 0px', // '-50% 0px' = ビューポートの中心が判定基準
      threshold: 0, // 閾値
    };
    // 監視開始
    const observerHeader = new IntersectionObserver((entries) => {
      entries.forEach(_entry => {
        if (_entry.isIntersecting) {
          this.elmHeader.classList.remove('is-scrolled');
          this.elmFixedBtn.classList.remove('is-scrolled');
        } else {
          this.elmHeader.classList.add('is-scrolled');
          this.elmFixedBtn.classList.add('is-scrolled');
        }
      });
    });
    observerHeader.observe(this.elmTargetObserve, options);
  }

}
